import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import Logo from "../../assets/icons/Site_Logo.png";

export default function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  return (
    <>
      <nav className="navbar">
        <div className="nav-container container">

          <NavLink exact to="/" className="nav-logo">
            <img src={Logo} alt="logo" />
          </NavLink>

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/aboutus"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                About Us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/services"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/projects"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Projects
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                exact
                to="/energysector"
                activeClassName="active"
                className="nav-links"
                onClick={handleClick}
              >
                Energy Sector
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                exact
                to="/inhouseexpertise"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                In-House Expertise
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                exact
                to="/articles"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                News
              </NavLink>
            </li> */}
            <li className="nav-item get-in-touch">
              <NavLink
                exact
                to="/getintouch"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Get In Touch
              </NavLink>
            </li>
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
          </div>
        </div>
      </nav>
    </>
  );
}
